import { render } from "./CadFormPage.vue?vue&type=template&id=67fc9590&scoped=true"
import script from "./CadFormPage.vue?vue&type=script&lang=js"
export * from "./CadFormPage.vue?vue&type=script&lang=js"

import "./CadFormPage.vue?vue&type=style&index=0&id=67fc9590&scoped=true&lang=css"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fc9590"]])

export default __exports__